import React from 'react';
import { Link } from 'react-router-dom'; // If using React Router
import img1 from "../../assests/Logo/Mr .PDF.svg";
import img2 from "../../assests/Icons/insta.svg";
import img3 from "../../assests/Icons/linkdin.svg";
import img4 from "../../assests/Icons/Twitter(x).svg";
import './Footer.css';

const Footer = () => {
  const footerSections = [
    {
      title: "Product",
      links: [
        { name: "Home", url: "/" },
        // { name: "Features", url: "/features" },
        { name: "All Tools", url: "/Allpage" }
      ]
    },
    {
      title: "Popular Tools",
      links: [
        // { name: "Merge PDF", url: "/" },
        { name: "Split PDF", url: "/upload-split" },
        { name: "Compress PDF", url: "/compress-pdf" },
        { name: "Edit PDF", url: "/upload-edit" },
        { name: "PDF to Word", url: "/pdf-to-word" },
        { name: "JPG to PDF", url: "/upload-jpg" }
      ]
    },
    {
      title: "More Tools",
      links: [
        // { name: "Rotate PDF", url: "/rotate-pdf" },
        { name: "Watermark PDF", url: "/upload-edit" },
        { name: "Highlight PDF", url: "/highlight-pdf" },
        { name: "Delete Pages", url: "/delete" },
        { name: "Add Pages", url: "/add-preview" },
        // { name: "Page Number PDF", url: "/page-number-pdf" },
        // { name: "Unlock PDF", url: "/unlock-pdf" }
      ]
    },
    // {
    //   title: "Shipping Labels",
    //   links: [
    //     { name: "Flipkart Label", url: "/flipkart-label" },
    //     { name: "Meesho Label", url: "/meesho-label" },
    //     { name: "Amazon Label", url: "/amazon-label" }
    //   ]
    // },
    {
      title: "Legal",
      links: [
        { name: "Privacy Policy", url: "/privacy-policy" },
        { name: "Terms & Conditions", url: "/terms-conditions" },
        // { name: "Services", url: "/services" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "About Us", url: "/about-us" },
        { name: "Contact", url: "/contact" },
        // { name: "Blog", url: "/blog" }
      ]
    }
  ];

  const socialLinks = [
    // { name: "Instagram", icon: img2, url: "https://instagram.com/mrpdf" },
    // { name: "LinkedIn", icon: img3, url: "https://linkedin.com/company/mrpdf" },
    // { name: "Twitter", icon: img4, url: "https://twitter.com/mrpdf" }
  ];

  // Smooth scroll to top
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Get current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        {/* Footer Navigation Grid */}
        <nav className="footer-grid" aria-label="Footer Navigation">
          {footerSections.map((section, idx) => (
            <div key={idx} className="footer-col">
              <h4>{section.title}</h4>
              <ul>
                {section.links.map((link, i) => (
                  <li key={i}>
                    <a
                      href={link.url}
                      aria-label={`Navigate to ${link.name}`}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-brand">
            <a
              href="/"
              className="nav-logo"
              onClick={scrollToTop}
              aria-label="Mr.PDF - Scroll to top"
            >
              <img src={img1} alt="Mr.PDF Logo" />
            </a>
            <p className="copyright">
              © {currentYear} Mr.PDF. All rights reserved.
            </p>
          </div>
          <div>
            {/* <p>Made With ❤️ By Vivek Pansheriya</p>
            <p>Contact -7435087452</p> */}
          </div>
          {/* Social Media Links */}
          <div className="footer-socials" role="navigation" aria-label="Social Media">
            {socialLinks.map((social, idx) => (
              <a
                key={idx}
                href={social.url}
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit our ${social.name} page`}
              >
                <img src={social.icon} alt={`${social.name} icon`} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
